import React from 'react';
import {MasterLayout} from 'layout';
import { DanhSachTheoDoiThucHien } from 'modules/theo-doi-thuc-hien';

class DanhSachTheoDoiThucHienPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <DanhSachTheoDoiThucHien/>
      </MasterLayout>
    );
  }
}

export default DanhSachTheoDoiThucHienPage;


// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-thuc-hien/DanhSachTheoDoiThucHienPage.jsx